<template>
    <div class="LifeskillSelection">
        <div class="top-part">
            <h3>{{ $t('title') }}</h3>
            <AnimatedNumbershape class="numbershape" :number="number" reversed :play="true" />
        </div>

        <div class="bottom-part">
            <div
                v-for="stepItem of randomStepItems"
                :key="stepItem.data.life_area"
                class="select-option"
                @click="validateUserChoice(stepItem, $event.target)"
            >
                {{ stepItem.data.life_area }}
            </div>
        </div>
    </div>
</template>

<translations>
  title: 'Which lifeskill is this icon?'
  title_no: 'Hvilket livsområde hører til dette ikonet?'
</translations>

<script>
import AnimatedNumbershape from '@/components/AnimatedNumbershape';
import soundService from '@/services/sound-service';
import correctSound from '@/assets/sounds/correct-answer.mp3';

export default {
    components: {
        AnimatedNumbershape
    },

    props: {
        number: {
            type: String,
            required: true
        },

        randomStepItems: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            isFeedbakcPlaying: false
        };
    },

    methods: {
        validateUserChoice(item, clickedElement) {
            item.isCurrentStepItem
                ? this.handleCorrectFeedback(clickedElement)
                : this.handleWrongFeedback(clickedElement);
        },

        handleCorrectFeedback(element) {
            if (!this.isFeedbakcPlaying) {
                this.setFeedbackPlaying(true);

                soundService.play(correctSound);

                element.classList.add('good-answer');

                setTimeout(() => {
                    this.$emit('userAnsweredCorrectly');

                    this.setFeedbackPlaying(false);
                }, 500);
            }
        },

        handleWrongFeedback(element) {
            if (!this.isFeedbakcPlaying) {
                this.setFeedbackPlaying(true);

                element.classList.add('wrong-answer');

                setTimeout(() => {
                    element.classList.remove('wrong-answer');

                    this.setFeedbackPlaying(false);
                }, 1000);
            }
        },

        setFeedbackPlaying(flag) {
            this.isFeedbakcPlaying = flag;
        }
    }
};
</script>

<style lang="scss" scoped>
.LifeskillSelection {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px;
    .top-part {
        display: flex;
        flex-direction: column;
        align-items: center;
        h3 {
            text-align: center;
        }
        .numbershape {
            width: 100px;
            height: 100px;
            background: white;
            border-radius: 10px;
        }
    }

    .bottom-part {
        width: 100%;
        .select-option {
            height: 50px;
            background-color: white;
            border-radius: 10px;
            color: black;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 5px;
            cursor: pointer;
            &.wrong-answer {
                background-color: rgb(213, 120, 222);
                color: white;
                animation: shake 1s;
            }
            &.good-answer {
                background-color: rgb(213, 120, 222);
                color: white;
                transform: scale(1.2);
                transition: 0.5s;
            }
        }
    }
}

@keyframes shake {
    0% {
        transform: translateX(10px);
    }
    12% {
        transform: translateX(-10px);
    }
    25% {
        transform: translateX(10px);
    }
    37% {
        transform: translateX(-10px);
    }
    50% {
        transform: translateX(10px);
    }
    62% {
        transform: translateX(-10px);
    }
    75% {
        transform: translateX(10px);
    }
    87% {
        transform: translateX(-10px);
    }
    100% {
        transform: translateX(10px);
    }
}
</style>
